export default "__VITE_ASSET__O9tUiwOf__"